// extracted by mini-css-extract-plugin
export default {"table":"FeesTable__table-rs23"};